module.exports = __webpack_public_path__ + "img/gw.ac71ef84.svg";